<template>
  <div class="p-10 bg-grey-90 <md:px-4">
    <p :class="brandClasses.heading">
      {{ $t.loyaltyBenefitsTitle }}
    </p>
    <p v-if="showSubtitle" class="text-sm mb-4">
      {{ $t.loyaltyBenefitsSubtitle }}
    </p>
    <div class="c-black fw-light space-y-4">
      <div v-for="({ icon, text }, key) in benefits" :key class="flex items-center">
        <img alt="" :src="icon" :width="iconWidth">
        <p class="ml-4 ws-pre-wrap">
          <base-interpolator :content="$t[text]">
            <template v-for="(to, i) in links" #[i]="{ args: [message] }" :key="i">
              <vf-link :class="linkClasses?.[i]" :data-test-id="dataTestIds?.[key]" target="_blank" :to>
                {{ message }}
              </vf-link>
            </template>
          </base-interpolator>
        </p>
      </div>
      <p v-if="showDiscountNote" class="text-sm">
        {{ $t.loyaltyBenefitsDiscountNote }}
      </p>
    </div>
    <div class="mt-4 space-y-4">
      <slot name="loyalty-terms" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

defineProps<{
  dataTestIds?: Partial<{ [K in keyof typeof links]: string }>
  linkClasses?: Partial<{ [K in keyof typeof links]: CSSClass }>
}>()

const {
  benefits,
  brandClasses,
  iconWidth,
  showDiscountNote,
  showSubtitle
} = useAppConfig().components.loyalty.benefits

const links = {
  'shipping-terms': '/policies/shipping-terms',
  'loyalty': '/xplr-pass',
}
</script>
